import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MyBuildingService } from './my-building.service';

export const myBuildingBreadcrumbResolver = (route: ActivatedRouteSnapshot) => {
	const buildingId = route.paramMap.get('buildingId');

	return inject(MyBuildingService).getCurrentBuildingBreadcrumb(buildingId);
};
